<template>
  <div>
    <h1>Leistungen Visieren</h1>
    <v-snackbar v-model="snackbar.visible"
                :timeout="snackbar.timeout"
                :color="snackbar.color"
                top>
      {{ snackbar.text }}
    </v-snackbar>
    <v-data-table :headers="headers" :items="items" :search="search" :single-expand="true" :expanded.sync="expanded"
                  show-expand @click:row="(item, slot) => slot.expand(!slot.isExpanded)" id="data-table" :custom-filter="customSearch">
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-text-field
              v-model="search"
              append-icon="search"
              label="Leistung Suchen"
              single-line
              hide-details
              solo
          ></v-text-field>
          <ServiceModal v-model="editedService" :open="editModal" title="Bearbeiten" v-on:close="() => editModal = false" v-on:save="save"/>
        </v-toolbar>
      </template>
      <template v-slot:item.description="{ item }">
        <router-link :to="'/services/'+item.id">
          {{ item.description }}
        </router-link>
      </template>
      <template v-slot:item.account="{ item }">
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <div v-on="on">
              <router-link :to="'/users/'+item.accountId">
                {{ item.account != null ? item.account.firstname : "None" }}
                {{ item.account != null ? item.account.lastname : "None" }}
              </router-link>
            </div>
          </template>
          <span>{{ item.account != null ? item.account.email : "None" }}</span>
        </v-tooltip>
      </template>
      <template v-slot:item.confirmed="{ item }">
        <v-simple-checkbox color="primary" v-on:input="update(item)" v-model="item.confirmed"></v-simple-checkbox>
      </template>
      <template v-slot:expanded-item="{ headers, item }">
        <td :colspan="headers.length">
          <v-container style="max-width: 750px">
            <v-row no-gutters>
              <v-col cols="12" sm="6" md="12">
                <v-label>Leistungstyp</v-label>
                <p>{{item.serviceType.name}}</p>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-label>Startdatum</v-label>
                <p>{{new Date(item.startDate.substr(0, 10)).toLocaleDateString('ch-DE')}}</p>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-label>Enddatum</v-label>
                <p>{{new Date(item.endDate.substr(0, 10)).toLocaleDateString('ch-DE')}}</p>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-label>Tätigkeit Kurz Kat-I</v-label>
                <p>{{item.shortActivityCount}}</p>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-label>Anzahl Freiwillige (Kat-I)</v-label>
                <p>{{item.shortActivityVolunteerCount}}</p>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-label>Tätigkeit Halbtag Kat-II</v-label>
                <p>{{item.halfDayActivityCount}}</p>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-label>Anzahl Freiwillige (Kat-II)</v-label>
                <p>{{item.halfDayActivityVolunteerCount}}</p>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-label>Tätigkeit Ganztag Kat-III</v-label>
                <p>{{item.fullDayActivityCount}}</p>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-label>Anzahl Freiwillige (Kat-III)</v-label>
                <p>{{item.fullDayActivityVolunteerCount}}</p>
              </v-col>

            </v-row>
            <v-btn v-on:click="editService(item)">Korrektur</v-btn>
          </v-container>
        </td>
      </template>
    </v-data-table>
  </div>
</template>

<script>

import {serviceService} from "../services/serviceService";
import ServiceModal from "../components/ServiceModal";
import {accountService} from "@/services/accountService";

export default {
  name: "ConfirmServices",
  components: {ServiceModal},
  data: () => ({
    expanded: [],
    headers: [
      {
        text: "Leistung",
        value: "description"
      },
      {
        text: "Leistungserbringer",
        value: "account"
      },
      {
        text: "Visieren",
        value: "confirmed"
      },
      { text: 'Details', value: 'data-table-expand' }
    ],
    search: "",
    items: [],
    serviceTypes: [],
    editedIndex: -1,
    editedService: {
      id: 0,
      description: "",
      confirmed: false,
      startDate: new Date().toISOString().substr(0, 10),
      endDate: new Date().toISOString().substr(0, 10),
      shortActivityCount: 0,
      shortActivityVolunteerCount: 0,
      halfDayActivityCount: 0,
      halfDayActivityVolunteerCount: 0,
      fullDayActivityCount: 0,
      fullDayActivityVolunteerCount: 0,
      serviceType: null,
      serviceTypeId: 0,
      account: null,
      accountId: 0
    },
    editModal: false,
    snackbar: {
      visible: false,
      text: "",
      timeout: 5000,
      color: ""
    },
  }),
  methods: {
    customSearch (value, search, item) {
      search = search.toLowerCase();
      return item && (item.description.toLowerCase().includes(search) ||
          (item.account && (item.account.firstname.toLowerCase() + " " + item.account.lastname.toLowerCase()).includes(search)) ||
          item.serviceType && item.serviceType.name.toLowerCase().includes(search)
      );
    },
    update(item) {
      let self = this;
/*      item.account = null;
      item.serviceType = null;*/
      serviceService.confirmService(item)
          .then(() => {
            self.showSnackbar("Leistung visiert", "success");
          })
          .catch(error => {
            console.log(error)
            if(error.response.status === 400)
              self.showSnackbar(error.response.body, "error")
            else
              self.showSnackbar("Ein Fehler ist aufgetreten");
          });

    },
    showSnackbar(text, color = "red") {
      this.snackbar.text = text;
      this.snackbar.color = color;
      this.snackbar.visible = true;
    },
    save() {
      let service = Object.assign({}, this.editedService)
      service.startDate = this.editedService.startDate + "T00:00:00";
      service.endDate = this.editedService.endDate + "T00:00:00";
      service.account = null;
      service.serviceType = null;
      let self = this;
        serviceService.updateService(service).then((response) => {
          response.serviceType = self.serviceTypes.find(value => value.id === response.serviceTypeId);
          Object.assign(self.items[self.editedIndex], response);
          self.editModal = false;
        }).catch((error) => {
          if(error.response.status === 401) {
            self.showSnackbar(error.response.data)
          } else if(error.response.status === 400) {
            self.showSnackbar(error.response.data);
          } else {
            self.showSnackbar("Ein Fehler ist aufgetreten");
            console.log(error);
          }
        })
    },
    editService(service) {
      this.editedIndex = this.items.indexOf(service)
      this.editedService = Object.assign({}, service)
      this.editedService.startDate = this.editedService.startDate.substr(0, 10)
      this.editedService.endDate = this.editedService.endDate.substr(0, 10)
      this.editModal = true;
    },
  },
  created() {
    let self = this;
    serviceService.getServiceTypes().then((serviceTypes) => {
      self.serviceTypes = serviceTypes;
    }).catch((error) => {
      console.log(error);
    });
    serviceService.getServices().then(services => {
      self.items = services.filter(service => !service.confirmed)
    }).catch((error) => {
      console.log(error);
      accountService.refreshToken().then(() => this.created()).catch(() => accountService.signOut())
    });
    document.title = "Leistungen Visieren";
    //serviceService.getQuery("confirmed=false").then(value => self.items = value);
  }
}
</script>

<style scoped>
#data-table {
  width: 50vw;
}
</style>